import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import WeatherWidget from './WeatherWidget';

// Barra fina usada em todas as páginas públicas de enquete (dinâmicas e as
// duas legadas). "Voltar" à esquerda, previsão do tempo de hoje/amanhã à
// direita. Sempre renderizada IMEDIATAMENTE DEPOIS do header de cada página
// (nunca antes) — o header fica em fluxo normal (não "sticky"), então ao
// carregar a página esta faixa aparece colada embaixo dele; só quando o
// usuário rola e o header sai da tela ela "gruda" no topo (comportamento
// nativo do position:sticky), voltando a ficar embaixo do header quando a
// página volta ao topo.
const SubheaderVoltar = () => (
  <div className="sticky top-0 z-40 bg-[#40A1E6] backdrop-blur-sm px-4 py-2 shadow-lg">
    <div className="max-w-5xl mx-auto flex items-center justify-between">
      <Link
        to="/"
        className="flex items-center gap-1.5 text-white text-sm font-medium rounded-full border border-white px-3 py-1 hover:bg-white/10 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> Voltar
      </Link>
      <WeatherWidget />
    </div>
  </div>
);

export default SubheaderVoltar;
